<div class="card tw-min-h-[300px]">
	<app-component-loader [loading]="LoaderService.loadingAssessmentsBar"></app-component-loader>
	<div class="card-header" *ngIf="graphData" data-html2canvas-ignore>
		{{ graphData.progressDataSchool[0].graphTitle }}
	</div>
	<div>
		<div id="assessed-graph"></div>
	</div>
</div>
